const LOGIN = '/login';
const LOGOUT = '/logout';
const CALLBACK = '/callback';

export { CALLBACK, LOGIN, LOGOUT };
